<template>
  <div class="col-lg-12 col-md-12" v-if="orderStats !== null">
    <!-- Menu and Filters -->
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>
    <div v-if="orderStats.length !== null">
      <div class="row" style="margin-left: 5px">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="col-md-6" v-if="$route.query.campaign !== undefined">
          <h4>Campaign Sales</h4>
        </div>
        <div class="col-md-6" v-else-if="$route.query.code !== undefined">
          <h4>Sales by discount {{ $route.query.code }}</h4>
        </div>
        <div class="col-md-6" v-else-if="$route.query.influencer !== undefined">
          <div v-if="influencerDetails !== null">
            <h4 v-if="influencerDetails.instagramProfile !== undefined">
              Sales from @{{ influencerDetails.instagramProfile }}
            </h4>
          </div>
        </div>
        <div class="col-md-3" v-else>
          <h4>Store Sales</h4>
        </div>
        <div class="col-md-9">
          <div style="padding: 10px; margin-top: 10px; float: right">
            <p-button color="success" class="mr-4" @click="resetDates">
              Select
            </p-button>
          </div>
          <div style="padding: 10px; float: right">
            Ending
            <datepicker
              v-model="pickerEnd"
              placeholder="Select Date:"
              name="campaignStart"
              input-class="calendar-input-analytics"
              format="M/d/yy"
              :use-utc="true"
            />
          </div>
          <div style="padding: 10px; float: right">
            Starting
            <datepicker
              v-model="pickerStart"
              placeholder="Select Date:"
              name="datStart"
              input-class="calendar-input-analytics"
              format="M/d/yy"
              :use-utc="true"
            />
          </div>
        </div>
      </div>
      <!-- Summary -->
      <div class="row">
        <!-- Total Sales -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="primary"
            icon="fas fa-chart-line"
            small-title="Total Sales"
            :title="
              new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
              }).format(orderSummary.totalSales)
            "
          />
        </div>
        <!-- Order Count -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="primary"
            icon="fas fa-chart-line"
            small-title="Orders"
            :title="orderSummary.orderCount.toString()"
          />
        </div>
        <!-- AVG Order Value -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="primary"
            icon="fas fa-chart-line"
            small-title="AVG Order Value"
            :title="
              new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
              }).format(orderSummary.averageOrderValue)
            "
          />
        </div>
        <!-- Influencer Count -->
        <div class="col-lg-3 col-md-6 col-sm-6">
          <stats-card
            type="primary"
            icon="fas fa-chart-line"
            small-title="Influencers Count"
            :title="orderSummary.influencerCount.toString()"
          />
        </div>
      </div>
      <!-- Data Table -->
      <div class="row">
        <div class="col-md-12">
          <div class="card" style="padding-left: 15px">
            <div class="card-header">
              <h5 class="title" v-if="orderSummary !== null">
                {{ orderSummary.orderCount }} Orders
              </h5>
              <h5 class="title" v-else>No Orders</h5>
            </div>
            <div v-if="loadShopifyOrderStats !== null">
              <b-table
                id="order-stats-table"
                :items="loadShopifyOrderStats"
                :fields="columns"
                :current-page="currentPage"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :busy.sync="isLoading"
              >
                <template #table-busy>
                  <div class="text-center" style="margin-top: 10px">
                    <b-spinner
                      class="align-middle"
                      style="margin-right: 10px"
                    ></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <!-- Order Id -->
                <template #cell(orderId)="row">
                  <div style="width: 100%; text-align: center">
                    <a
                      :href="
                        `https://${$route.params.shop}/admin/orders/${row.item.orderId}`
                      "
                      target="_blank"
                    >
                      #{{ row.item.orderNumber }}
                    </a>
                  </div>
                </template>
                <!-- Date -->
                <template #cell(date)="row">
                  <div style="text-align: center">
                    {{ row.item.orderCreatedString }}
                  </div>
                </template>
                <!-- Value -->
                <template #cell(value)="row">
                  <div style="width: 100%; text-align: center">
                    {{
                      new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(row.item.priceTotal)
                    }}
                  </div>
                </template>
                <!-- Discount -->
                <template #cell(discount)="row">
                  <div
                    style="width: 100%; text-align: center"
                    v-if="row.item.discountDetails !== undefined"
                  >
                    <a
                      :href="
                        '/shopify/discounts/details/' +
                          row.item.discountDetails._id
                      "
                    >
                      {{ row.item.discountCodeString }}
                    </a>
                  </div>
                  <div v-else>-</div>
                </template>
                <!-- Influencer -->
                <template #cell(influencer)="row">
                  <div style="width: 100%; text-align: center">
                    <a
                      :href="
                        `/influencer-campaign/influencer/${row.item.influencerId}`
                      "
                    >
                      <img
                        :src="row.item.influencer.profilePicCache"
                        class="influencer-img"
                        v-if="row.item.influencer.profilePicCache !== undefined"
                      />
                      <img
                        :src="row.item.influencer.profilePic"
                        class="influencer-img"
                        @error="
                          profilePicLoadCache(row.item.influencer.profileName)
                        "
                        v-else
                      />
                    </a>
                    <br />
                    <a
                      :href="
                        `/influencer-campaign/influencer/${row.item.influencerId}`
                      "
                    >
                      @{{ row.item.influencer.profileName }}
                    </a>
                  </div>
                </template>
              </b-table>
              <b-col
                style="width: 500px;padding: 20px;text-align: center;margin: auto"
              >
                <b-pagination
                  v-model="currentPage"
                  :disabled="isLoading"
                  :total-rows="orderSummary.orderCount"
                  :per-page="perPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                />
              </b-col>
            </div>
          </div>
          <!-- Rows Table -->
          <div style="padding: 10px; float: left">
            Rows
            <select v-model="perPage" class="custom-select">
              <option
                v-for="option in ['25', '50']"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="lds-dual-ring"></div>
  </div>
</template>
<script>
import firebase from "firebase";

import { mapGetters, mapActions } from "vuex";
import {
  Card,
  Checkbox,
  Button,
  Modal,
  Badge,
} from "@/components/UIComponents";
import ChartCard from "@/components/UIComponents/Cards/ChartCard";
import StatsCard from "@/components/UIComponents/Cards/StatsCard";
import Loading from "@/components/Dashboard/Layout/LoadingMainPanel.vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import _ from "underscore";
import timeVars from "@/config/timeVars";
//import TaskList from "./Widgets/TaskList";

import {
  userLoadApi,
  userRelatedProfilesApi,
  fbGraphCreateProfile,
  fbGraphInstagramCheck,
  influencerCampaignAnalyticsReadApi,
  influencerCampaignReadApi,
  influencerCollabPostSearchApi,
  instagramProfileCacheApi,
  shopifyOrderAnalyticsApi,
  influencerCampaignCandidateReadApi,
  influencerCandidateReadApi,
} from "@/config/appSettings";
import axios from "axios";
export default {
  name: "ShopifyOrderAnalytics",
  components: {
    Card,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    StatsCard,
    ChartCard,
    Datepicker,
    Badge,
    Modal,
  },
  data() {
    return {
      columns: [
        {
          key: "orderId",
          label: "Order Id",
          sortable: true,
          class: "text-center",
        },
        { key: "date", label: "Date", sortable: false, class: "text-center" },
        { key: "value", label: "Value", sortable: false, class: "text-center" },
        {
          key: "discount",
          label: "Discount",
          sortable: false,
          class: "text-center",
        },
        {
          key: "influencer",
          label: "Influencer",
          sortable: false,
          class: "text-center",
        },
      ],
      isLoading: false,
      currentPage: 1,
      perPage: 25,
      sortBy: "date",
      sortDesc: true,
      sortDirection: "asc",
      isConnected: false,
      isTeam: null,
      isClient: null,
      isInfluencer: null,
      profileDetails: null,
      auth: null,
      relatedProfiles: null,
      noAuthProfiles: [],
      campaignDetails: null,
      orderStats: null,
      orderSummary: null,
      loadingOverlay: false,
      loadingOverlayText: null,
      postList: [],
      influencerList: [],
      analyticsView: "store",
      startDate: null,
      endDate: null,
      pickerStart: null,
      pickerEnd: null,
      campaignId: null,
      influencerId: null,
      influencerDetails: null,
    };
  },
  computed: {
    ...mapGetters(["profileStore"]),
  },
  methods: {
    async setProfileType() {
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
            return;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            console.log("ERROR:", err);
          }
        }
      }
    },
    async profilePicLoadCache(instagramProfile) {
      try {
        let profileCacheUrl = `${instagramProfileCacheApi}/?usertoken=${this.auth}&instagram=${instagramProfile}`;
        //console.log("PROFILE CACHE:", profileCacheUrl);
        let profileCacheResponse = await axios.get(profileCacheUrl);
        //

        //console.log(`LOADING ${instagramProfile}`, profileCacheResponse.data);
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (this.relatedProfileStore === false) {
          let relatedProfileResponse = await axios.get(
            `${userRelatedProfilesApi}/?usertoken=${this.auth}`
          );
          this.relatedProfiles = relatedProfileResponse.data.result;
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
    async checkNoAuthProfiles() {
      if (this.relatedProfiles.length > 0) {
        let instagramProfileString = this.relatedProfiles.join(",");
        let noAuthProfileCheckResponse = await axios.get(
          `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
        );
        //console.log("RELATED PROFILE AUTH CHECK:", noAuthProfileCheckResponse);
        if (noAuthProfileCheckResponse.data.exists === false) {
          this.noAuthProfiles = noAuthProfileCheckResponse.data.result;
        }
      }
    },
    async loadShopifyOrderStats() {
      //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
      try {
        this.isLoading = true;
        let orderAnalyticsUrl = `${shopifyOrderAnalyticsApi}/?usertoken=${this.auth}&shop=${this.$route.params.shop}&page=${this.currentPage}&limit=${this.perPage}`;

        if (typeof this.$route.query.code !== "undefined") {
          orderAnalyticsUrl = `${orderAnalyticsUrl}&code=${this.$route.query.code}`;
        }
        if (typeof this.$route.query.campaign !== "undefined") {
          orderAnalyticsUrl = `${orderAnalyticsUrl}&campaign=${this.$route.query.campaign}`;
        }
        if (typeof this.$route.query.influencer !== "undefined") {
          orderAnalyticsUrl = `${orderAnalyticsUrl}&influencer=${this.$route.query.influencer}`;
          this.loadInfluencer();
        }
        if (typeof this.$route.query.page !== "undefined") {
          orderAnalyticsUrl = `${orderAnalyticsUrl}&influencer=${this.$route.query.page}`;
        }
        if (this.startDate !== null) {
          orderAnalyticsUrl = `${orderAnalyticsUrl}&start=${this.startDate}`;
        }
        if (this.endDate !== null) {
          orderAnalyticsUrl = `${orderAnalyticsUrl}&end=${this.endDate}`;
        }

        // orderAnalyticsUrl += `&page=1&limit=5`

        //console.log("SENDING ORDER ANALYTICS URL:", orderAnalyticsUrl);

        let orderAnalyticsResponse = await axios.get(orderAnalyticsUrl);
        console.log(
          "HERE IS THE CAMPAIGN LOADING:",
          orderAnalyticsResponse.data
        );
        this.orderStats = null;
        this.orderSummary = null;
        if (orderAnalyticsResponse.data.success === true) {
          this.orderStats = orderAnalyticsResponse.data.result.filter((x) => {
            return typeof x.influencer !== "undefined";
          });

          if (typeof orderAnalyticsResponse.data.summary !== "undefined") {
            this.orderSummary = orderAnalyticsResponse.data.summary;
          }
        }
        this.isLoading = false;
        this.loadingText = "There was a stats error. Refresh page.";
        return this.orderStats;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadCampaign() {
      try {
        //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
        let campaignLoadResponse = await axios.get(
          `${influencerCampaignReadApi}/?usertoken=${this.auth}&campaign=${this.$route.query.campaignId}`
        );
        /*console.log(
        "HERE IS THE CAMPAIGN LOAD RESPONSE:",
        campaignLoadResponse.data
      );*/
        if (campaignLoadResponse.data.success === true) {
          this.campaignDetails = campaignLoadResponse.data.result;

          return;
        }
        this.loadingText = "There was an error loading. Refresh page.";
      } catch (err) {
        //console.log("ERR", err);
      }
    },
    async loadInfluencer() {
      try {
        //console.log("HERE IS THE CAMPAIGN ID:", campaignId);
        let influencerLoadResponse = await axios.get(
          `${influencerCandidateReadApi}/?usertoken=${this.auth}&influencer=${this.$route.query.influencer}`
        );

        //console.log("LOAD RESPONSE:", influencerLoadResponse.data);

        if (influencerLoadResponse.data.success === true) {
          //console.log("INFLUENCER DETAILS", this.influencerDetails);
          this.influencerDetails = influencerLoadResponse.data.result;

          return;
        }
        this.loadingText = "There was an error loading. Refresh page.";
      } catch (err) {
        console.log("ERR", err);
      }
    },
    async formatDate(dateInput) {
      let thisDate = moment(dateInput).format("yyyy-MM-DD");
      //console.log("THIS DATE:", thisDate);
    },
    async resetDates() {
      try {
        //console.log("START DATE", this.pickerStart);
        let startDateString = new Date(this.pickerStart); // Your timezone!
        this.startDate = startDateString.getTime() / 1000;
        //console.log("START TIMESTAMP: ", this.startDate);
        //console.log("END DATE", this.pickerEnd);
        let endDateString = new Date(this.pickerEnd); // Your timezone!
        this.endDate = endDateString.getTime() / 1000;
        //console.log("END TIMESTAMP: ", this.endDate);
        if (this.startDate < this.endDate) {
          let startDateUrl = moment
            .unix(this.startDate)
            .startOf("day")
            .format("YYYY-MM-DD");
          let endDateUrl = moment
            .unix(this.endDate)
            .endOf("day")
            .format("YYYY-MM-DD");
          this.analyticsData = null;
          await this.loadShopifyOrderStats();

          if (
            startDateUrl == this.$route.query.start &&
            endDateUrl == this.$route.query.end
          ) {
            return;
          }

          this.$router.push(
            `/shopify/orders/${this.$route.params.shop}/?start=${startDateUrl}&end=${endDateUrl}`
          );
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      try {
        this.getTime = await timeVars.timeInfo();
        //console.log("UTC TIME:", this.getTime.utcTime);

        this.endDate =
          moment
            .unix(this.getTime.utcTime)
            .startOf("day")
            .utc() / 1000;
        this.startDate =
          moment
            .unix(this.endDate)
            .utc()
            .subtract(1, "month") / 1000;

        //console.log("GENERIC START DATE:", this.startDate);
        //console.log("GENERIC END DATE:", this.endDate);

        this.pickerStart = new Date(this.startDate * 1000);
        if (typeof this.$route.query.start !== "undefined") {
          let startTs =
            moment(this.$route.query.start)
              .utc()
              .valueOf() / 1000;
          //console.log("START TS:", startTs);
          if (!isNaN(startTs)) {
            this.startDate = startTs;
            this.pickerStart = new Date(startTs * 1000);
            //console.log("PICKER START:", this.pickerStart);
          }
        }
        this.pickerEnd = new Date(this.endDate * 1000);
        if (typeof this.$route.query.end !== "undefined") {
          let endTs =
            moment(this.$route.query.end)
              .utc()
              .valueOf() / 1000;
          //console.log("END TS:", endTs);
          if (!isNaN(endTs)) {
            this.endDate = endTs;
            this.pickerEnd = new Date(this.endDate * 1000);
            //console.log("PICKER END:", this.pickerEnd);
          }
        }
        if (typeof this.$route.query.influencer !== "undefined") {
          this.loadInfluencer();
        }

        await this.setProfileType();
        this.loadCampaign();
        this.loadShopifyOrderStats();
        this.loadingOverlay = false;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingText = "LOADING...";
    //console.log("SHOP:", this.$route.params.shop);
    //console.log("PAGE VIEW:", this.$route.query.view);
    if (typeof this.$route.query.view !== "undefined") {
      this.analyticsView = this.$route.query.view;
    }
    this.auth = firebase.auth().currentUser.uid;

    this.loadPageContent();
  },
  watch: {
    currentPage() {
      this.$root.$emit("bv::refresh::table", "order-stats-table");
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    perPage() {
      this.$root.$emit("bv::refresh::table", "order-stats-table");
    },
  },
};
</script>
<style scoped>
.center-align {
  text-align: center;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
.influencer-img {
  width: 50px;
  margin: 10px;
  border-radius: 5px;
}
</style>
